import React from 'react'
import { Drawer } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import ShiftStatusBar from './ShiftStatusBar';
import { formatDateReadable } from '../../utilities/helpers';
import DrawerHeader from '../../shared/helpers/DrawerHeader';
import DrawerFooterContainerSmall from '../../shared/helpers/DrawerFooterContainerSmall';
import ButtonFilled from '../../shared/helpers/ButtonFilled';
import ButtonGrayed from '../../shared/helpers/ButtonGrayed';
import ModalInfoCard from '../../shared/helpers/ModalInfoCard';
import {
  CalendarToday,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  WorkOutline,
  FreeBreakfastOutlined,
  PlaceOutlined
} from '@mui/icons-material';

function PendingTableEmployeeRowShiftDropDrawer(props) {

  function handleDropCancel() {
    props.rescind_drop_shift(props.shiftInfo.id);
  }

  return (
    <Drawer anchor="right" open={props.open} onClose={props.onClose}>
      <div className="w-[450px] h-full bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader title="Drop Request" onClose={props.onClose} />
          <div className="w-full px-6 mt-4">
            <div className="w-full pb-6 border-b border-slate-200">
              <ShiftStatusBar
                cardStatus={props.cardStatus}
                pendingPickupCount={props.shiftInfo.pending_pickup_count}
                renderAnimations={props.renderAnimations}
              />
            </div>
          </div>

          <div className="px-6 mt-6">

            <div className="mb-4 flex items-center space-x-4">
              <div className="flex-1">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Date"
                  value={formatDateReadable(props.shiftInfo?.date)}
                />
              </div>
              <div className="flex-1">
                <ModalInfoCard
                  icon={AccessTime}
                  title="Time"
                  value={props.shiftInfo?.shift}
                />
              </div>
            </div>

            <div className="mb-4 flex items-center space-x-4">
              <div className="flex-1">
                <ModalInfoCard
                  icon={FreeBreakfastOutlined}
                  title="Break"
                  value={props.shiftInfo.break_formatted}
                />
              </div>
              <div className="flex-1">
                <ModalInfoCard
                  icon={WorkOutline}
                  title="Role"
                  value={props.shiftInfo.station
                    ? props.shiftInfo.station?.name
                    : props.shiftInfo.role
                    ? props.shiftInfo.role
                    : props.shiftInfo.roleType}
                />
              </div>
            </div>

            {props.shiftInfo?.note &&
              <div className="mb-4">
                <ModalInfoCard
                  icon={ChatBubbleOutline}
                  title="Shift Note"
                  value={props.shiftInfo?.note}
                />
              </div>
            }

            {props.shiftInfo?.employee_drop_note &&
              <div className="mb-4">
                <ModalInfoCard
                  icon={ChatBubbleOutline}
                  title="Employee Drop Note"
                  value={props.shiftInfo?.employee_drop_note}
                />
              </div>
            }


            {props.shiftInfo.location && (
              <div className="mb-4">
                <ModalInfoCard
                  icon={PlaceOutlined}
                  title="Location"
                  value={props.shiftInfo?.location}
                />
              </div>
            )}

          </div>

          <DrawerFooterContainerSmall>
            <div className="w-full">
              {props.cardStatus === "pending" &&
              props.shiftInfo?.requestType === "Add to Pool Request" ? (
                <div className="w-full">
                  <ButtonFilled text="Cancel Request" onClick={() => handleDropCancel()} />
                </div>
              ) : (
                <div className="w-full">
                  <ButtonGrayed text="Cancel Request" />
                </div>
              )}
            </div>
          </DrawerFooterContainerSmall>
          <div className="h-[200px]"></div>
        </div>
      </div>
    </Drawer>
  )
}

export default PendingTableEmployeeRowShiftDropDrawer
